/**
 * Resizable Cart Drawer
 * Allows users to resize the cart drawer by dragging its left edge
 */
document.addEventListener('DOMContentLoaded', function() {
  const cartDrawer = document.getElementById('CartDrawer');
  
  if (!cartDrawer) {
    return;
  }

  const drawerInner = cartDrawer.querySelector('.drawer__inner');
  
  if (!drawerInner) {
    return;
  }

  const getMinDrawerWidth = () => 400;
  const getMaxDrawerWidth = () => window.innerWidth * 0.7;
  
  const resizeHandle = document.createElement('div');
  resizeHandle.className = 'drawer-resize-handle';
  drawerInner.appendChild(resizeHandle);
  
  let isResizing = false;
  let initialX;
  let initialWidth;
  
  resizeHandle.addEventListener('mousedown', initDrag);
  document.addEventListener('mousemove', dragMove);
  document.addEventListener('mouseup', dragEnd);
  
  function initDrag(e) {
    if (window.innerWidth <= 768) return;
    
    isResizing = true;
    initialX = e.clientX;
    initialWidth = parseInt(window.getComputedStyle(drawerInner).width, 10);
    
    document.body.classList.add('drawer-resizing');
    
    e.preventDefault();
  }
  
  function dragMove(e) {
    if (!isResizing) return;
    
    const currentX = e.clientX;
    const deltaX = initialX - currentX;
    let newWidth = initialWidth + deltaX;
    
    newWidth = Math.max(getMinDrawerWidth(), Math.min(newWidth, getMaxDrawerWidth()));
    
    drawerInner.style.width = `${newWidth}px`;
    
    localStorage.setItem('cartDrawerWidth', newWidth);
  }
  
  function dragEnd() {
    if (!isResizing) return;
    isResizing = false;
    document.body.classList.remove('drawer-resizing');
  }
  
  const savedWidth = localStorage.getItem('cartDrawerWidth');
  if (window.innerWidth > 768) {
    if (savedWidth) {
      const parsedWidth = parseInt(savedWidth, 10);
      const constrainedWidth = Math.max(getMinDrawerWidth(), Math.min(parsedWidth, getMaxDrawerWidth()));
      drawerInner.style.width = `${constrainedWidth}px`;
    } else {
      const defaultWidth = getMinDrawerWidth();
      drawerInner.style.width = `${defaultWidth}px`;
      localStorage.setItem('cartDrawerWidth', defaultWidth);
    }
  }
  
  let wasMobile = window.innerWidth <= 768;
  
  window.addEventListener('resize', function() {
    const isMobile = window.innerWidth <= 768;
    
    if (isMobile) {
      drawerInner.style.width = '';
      wasMobile = true;
      return;
    }
    
    if (wasMobile) {
      const savedWidth = localStorage.getItem('cartDrawerWidth');
      if (savedWidth) {
        const parsedWidth = parseInt(savedWidth, 10);
        const constrainedWidth = Math.max(getMinDrawerWidth(), Math.min(parsedWidth, getMaxDrawerWidth()));
        drawerInner.style.width = `${constrainedWidth}px`;
      }
      wasMobile = false;
      return;
    }
    
    const currentWidth = parseInt(window.getComputedStyle(drawerInner).width, 10);
    const minWidth = getMinDrawerWidth();
    const maxWidth = getMaxDrawerWidth();
    
    if (currentWidth < minWidth) {
      drawerInner.style.width = `${minWidth}px`;
      localStorage.setItem('cartDrawerWidth', minWidth);
    } else if (currentWidth > maxWidth) {
      drawerInner.style.width = `${maxWidth}px`;
      localStorage.setItem('cartDrawerWidth', maxWidth);
    }
  });
});
